import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';
import { requestCacheFn } from '@/utils/requestCache';

function requestCache(obj: Recordable) {
  return requestCacheFn(obj, request);
}

// code换取token
export function supplierLogin(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/supplier/pc/login.ac`,
    method: 'post',
    params,
  });
}

// 生产单列表
export function selectProduceList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/produce/selectProduceList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 生产单列表额外信息
export function selectProduceListExtra(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/produce/selectProduceListExtra.ac`,
    method: 'post',
    data,
  });
}

// 生产单详情
export function getProduceOrder(ordersSn: string) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/produce/getProduceOrder.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
}

// 查询所有自定义属性列表
export const getCustomAttributeListByWxa = (data: any, params: any = {}) => {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/attribute/combination/definition/page.ac`,
    method: 'post',
    data,
    params,
  });
};

export const getUsernameMapByWxa = () => {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/wxa/user/getUsernameMap.ac`,
    method: 'post',
  });
};

// 交货仓库列表
export function queryDeliveryStoreList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/basic/storehouse/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 物流列表
export function queryLogisticsList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/logistics/company/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 交货
export function approvalDelivery(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/goodsDelivery/approvalConfirm.ac`,
    method: 'post',
    data,
  });
}

// 交货记录
export function selectGoodsStoreInList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/goodsDelivery/selectGoodsStoreInList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 撤销交货单
export function destroyDeliveryOrder(ordersSn: string) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/goodsDelivery/destroy.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
}

// 获取交货单
export function getGoodsDeliveryOrder(ordersSn: string) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/goodsDelivery/getGoodsDeliveryOrder.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
}

// 获取生产入库单（小程序）
export function getProduceStoreInOrder(ordersSn: string) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/order/produceStoreIn/getOrder.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
}

// 系统配置
export function getSupplierConfig() {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/config/company/queryCompanyConfigList.ac`,
    method: 'post',
  });
}

// 编辑生产单
export function produceEdit(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/wxa/produce/edit.ac`,
    method: 'post',
    data,
  });
}
